module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getModalState) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal-box"
  }, [_c('div', {
    staticClass: "context",
    on: {
      "click": _vm.closeModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    style: ({
      width: _vm.$store.state.msgModal.setModal.width,
      height: _vm.$store.state.msgModal.setModal.height
    })
  }, [_c('span', {
    staticClass: "modal-close",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_vm._v(_vm._s(_vm.$store.state.msgModal.setModal.info))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-431abaa3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MsgModal.vue
// module id = 765
// module chunks = 1